"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceLanguagePlaceholders = exports.findLanguageObject = exports.includesLanguagePlaceholders = exports.languagePlaceholders = void 0;
exports.languagePlaceholders = {
    '%language%': lang => lang.name,
    '%two_letters_code%': lang => lang.twoLettersCode,
    '%three_letters_code%': lang => lang.threeLettersCode,
    '%locale%': lang => lang.locale,
    '%locale_with_underscore%': lang => { var _a; return (_a = lang.localeWithUnderscore) !== null && _a !== void 0 ? _a : lang.locale.replace(/-/g, '_'); },
    '%android_code%': lang => lang.androidCode,
    '%osx_code%': lang => lang.osxCode,
    '%osx_locale%': lang => lang.osxLocale,
};
function includesLanguagePlaceholders(str) {
    return Object.keys(exports.languagePlaceholders).some(placeholder => str.includes(placeholder));
}
exports.includesLanguagePlaceholders = includesLanguagePlaceholders;
function findLanguageObject(languageCode, languages, customLanguage) {
    let language;
    if (customLanguage) {
        language = {
            name: customLanguage.name,
            twoLettersCode: customLanguage.two_letters_code,
            threeLettersCode: customLanguage.three_letters_code,
            locale: customLanguage.locale,
            localeWithUnderscore: customLanguage.locale_with_underscore,
            androidCode: customLanguage.android_code,
            osxCode: customLanguage.osx_code,
            osxLocale: customLanguage.osx_code,
        };
    }
    else {
        language = languages.find(l => l.osxLocale === languageCode || l.locale === languageCode);
    }
    if (!language) {
        throw new Error(`Unsupported language code: ${languageCode}`);
    }
    return language;
}
exports.findLanguageObject = findLanguageObject;
function replaceLanguagePlaceholders(str, languageCode, languages, languageMapping, customLanguage) {
    const language = findLanguageObject(languageCode, languages, customLanguage);
    let result = str;
    for (const placeholder of Object.keys(exports.languagePlaceholders)) {
        if (result.includes(placeholder)) {
            const cleanPlaceholder = placeholder.slice(1, -1);
            const replaceValue = languageMapping && languageMapping[cleanPlaceholder]
                ? languageMapping[cleanPlaceholder]
                : exports.languagePlaceholders[placeholder](language);
            result = result.replace(placeholder, replaceValue);
        }
    }
    return result;
}
exports.replaceLanguagePlaceholders = replaceLanguagePlaceholders;
